import { Controller } from 'stimulus';
import { AddHoverHighlight, hideLoading, showLoading } from './param_redirect';

// Workstream C3: combo pages' "nearby" section pagination. Deliberately NOT modeled
// on pagination_controller.js -- there is no <a href="...?page=N">, no history push,
// no URL change at all. A plain fetch appends the next batch of already
// server-rendered cards; the button just disappears when there's nothing left.
export default class extends Controller {
  static targets = ['list', 'button'];

  static values = {
    url: String,
    offset: Number,
  };

  loadMore() {
    showLoading();
    const url = new URL(this.urlValue, window.location.origin);
    url.searchParams.set('offset', this.offsetValue);

    fetch(url.toString(), { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then(({ html, heading_html: headingHtml, next_offset: nextOffset, has_more: hasMore }) => {
        // F11 (FABLE round 3): a combo page whose primary list is bigger than one
        // page keeps extending that same primary list via Load More, with no
        // heading, until it's genuinely exhausted -- heading_html shows up
        // exactly once, on the batch where the server switches from "still
        // primary" to "actually nearby", so the "More doctors near you" heading
        // lands at the real boundary instead of the initial page's 20-card cap.
        if (headingHtml) {
          this.listTarget.insertAdjacentHTML('beforebegin', headingHtml);
        }
        this.listTarget.insertAdjacentHTML('beforeend', html);
        this.offsetValue = nextOffset;
        if (!hasMore) {
          this.buttonTarget.remove();
        }
        AddHoverHighlight();
        hideLoading();
      })
      .catch(() => {
        hideLoading();
      });
  }
}
